<template>
  <div class="job-dialog-container">
    <el-dialog
      class="job-dialog"
      :visible.sync="dialogShow"
      destroy-on-close
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="job-dialog-top">
        <p class="tit">{{ isEdit ? '职位信息修改' : '新增职位' }}</p>
        <i class="icon iconfont iconicon_close1 activeIconHover" @click="handleClose"></i>
      </div>

      <div class="job-dialog-content">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" size="large">
          <el-form-item label="职位名称" prop="job_name">
            <el-input v-model="ruleForm.job_name" placeholder="请输入职位名称" maxlength="20" clearable></el-input>
          </el-form-item>
          <el-form-item label="分组到" prop="job_type_id">
            <el-select v-model="ruleForm.job_type_id" placeholder="请选择" clearable>
              <el-option v-for="(item) in treeDataset" :key="item.id" :label="item.job_type_name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div class="job-dialog-footer">
        <span class="cancel text-btn-active" @click="handleClose">取消</span>
        <wf-button type="primary" :disabled="btnDisabled" @click="handldeSubmit" :loading="btnLoading">保存</wf-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/services/api/jobLevel/jobLevel'

export default  {
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    dataset: {
      type: Object,
      default: () => {
        return {}
      }
    },
    treeDataset: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // 保存按钮是否置灰
    btnDisabled() {
      return !this.ruleForm.job_name
    }
  },
  watch: {
  },
  data() {
    return {
      ruleForm: {
        job_id: '',
        job_type_id: 1,
        job_name: '',
        job_desc: ''
      },
      btnLoading: false,
      searchLoading: false,
      leaderList: [],
      departmentType: [],
      rules: {
        job_name: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        // job_desc: [{ required: true, message: '此项不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    if (this.isEdit) {
      this.init()
    } else {
      let { id } = this.dataset
      this.ruleForm.job_type_id = id || 0
      // console.log(this.ruleForm, 111)
    }

  },
  methods: {
    init () {
      let { id, job_type_id, job_name, job_desc } = this.dataset
      this.ruleForm = { job_id: id, job_type_id, job_name, job_desc }
    },
    resetForm() {
      this.ruleForm = {
        job_id: '',
        job_name: '',
        job_desc: ''
      }
      this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
    },
    handleClose() {
      this.resetForm()
      this.$emit('handleClose')
    },
    handldeSubmit() {
      this.btnLoading = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm))
          if (params.job_type_id === '') {
            params.job_type_id = 1
          }
          if (this.isEdit) {
            api.updateUserJbo(params).then(res => {
              this.$emit('complete')
              this.$message({ message: '职位更新成功', type: 'success' });
              this.btnLoading = false
            }).catch(err => {
              this.btnLoading = false
            })
          } else {
            api.addUserJbo(params).then(res => {
              this.$emit('complete')
              this.$message({ message: '职位新增成功', type: 'success' });
              this.btnLoading = false
            }).catch(err => {
              this.btnLoading = false
            })
          }
        } else {
          this.btnLoading = false;
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.job-dialog-container {
  .job-dialog {
    .el-dialog {
      width: 368px;
      .el-dialog__header {
        padding: 0 !important;
      }
      .el-dialog__body {
        padding: 0 !important;
        .job-dialog-top {
          width: 100%;
          padding: 24px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .tit {
            font-size: 18px;
            line-height: 22px;
          }
        }
        .job-dialog-content {
          .el-form {
            width: 100%;
            padding: 8px 24px 0;
            box-sizing: border-box;
            .el-form-item {
              width: 100%;
              margin-bottom: 24px;
            }
            .el-form-item__label {
              font-size: 14px;
              line-height: 20px;
              @include fontColorOpacity(.8);
              width: 100%;
              text-align: left;
            }
            // .el-input {
            //   height: 40px;
            //   .el-input__inner {
            //     height: 40px;
            //     line-height: 40px;
            //   }
            // }
            .el-select {
              width: 100%;
            }
          }
        }
        .job-dialog-footer {
          width: 100%;
          height: 32px;
          margin-bottom: 24px;
          padding: 0 24px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .wf-button {
            width: 76px;
            margin-left: 24px;
          }
        }
      }
    }
  }
}
</style>
